// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZkbP","textarea":"styles_textarea__1wuNF"};